import React, { useState, useEffect, useRef } from 'react';
import { Button, Box } from '@mui/material';
import "react-image-gallery/styles/css/image-gallery.css";
// import { Link } from 'react-router-dom';
import moment from 'moment';
import { classes as carouselClasses } from './CarouselStyles.js';
import CrsButton from './CarouselButton';

const classes = {
	allCarousel: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		width: '100%',
		height: 'auto',
		marginBottom: '44px',
	},
	backgroundClass:{
		backgroundSize: 'cover',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: '50% 50%',
		height: '100%',
		'@media screen and (max-width: 599px)': {
			backgroundSize: 'contain',
			background: 'black',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: '75% 50%',
		},
	},
	carouselFooter: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		background: '#F6F6FA 0% 0% no-repeat padding-box',
		boxShadow: '0px 3px 6px #00000029',
		borderRadius: '0px 0px 4px 4px',
		opacity: '1',
		width: '80%',
		height: 'auto',
		'@media screen and (max-width: 425px)': {
			width: '100%',
			background: '#EFEFEF 0% 0% no-repeat padding-box',
		},
	},
	carouselInfo: {
		width: '100%',
		height: 'auto',
		color: 'black',
		position: 'relative',
		bottom: 0,
		opacity: '1',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingBottom: '16px',
		marginTop: '-8px',
		fontFamily: 'Lato, sans-serif',
		webkitTransition: 'opacity 0.3s ease-in-out',
		'@media screen and (max-width: 599px)': {
			width: '90%',
			flexDirection: 'column',
			justifyContent: 'flex-end',
			borderRadius: '4px',
			marginTop: '8px',
		},
	},
	descriptionInfo: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		width: '100%',
		height: 'auto',
		padding: '0px 27px',
		font: 'normal normal bold 20px/24px Lato',
		letterSpacing: '0px',
		color: '#707070',
		opacity: '1',
		textAlign: 'left',
		justifyContent: 'flex-end',
		'@media screen and (max-width: 599px)': {
			textAlign: 'center',
			marginBottom: '16px',
			alignItems: 'center',
			padding: '0px',
		},
	},
	dateInfo: {
		font: 'normal normal normal 14px/17px Lato',
		marginTop: '4px',
		'@media screen and (max-width: 599px)': {
			textAlign: 'center',
		},
	},
	navContainter: {
		display: 'flex',
		width: '70px',
		paddingTop: '16px',
		justifyContent: 'space-between',
	},

	buttonContainer: {
		'@media screen and (max-width: 599px)': {
			textAlign: 'center'
		}
	},
	button: {
		background: '#D91B5B 0% 0% no-repeat padding-box',
		width: '175px',
		height: '35px',
		textTransform: 'initial',
		borderRadius: '4px',
		boxShadow: '0px 3px 6px #00000029',
		opacity: '1',
		textAlign: 'center',
		font: 'normal normal bold 16px/16px Lato',
		letterSpacing: '0px',
		color: '#FFFFFF',
		padding: '0px',
		marginRight: '27px',
		'&:hover': {
			background:'#D91B5B',
		},
		'@media screen and (max-width: 599px)': {
			marginRight: 0,
		},
	},
	buttonLink:{
		textTransform: 'initial',
		textDecoration: 'none',
		color: '#211D31',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		height: '100%',
		'@media screen and (max-width: 599px)': {
			marginRight: '0px',
		},
	},
}

function Carousel(props){
	const events = props.events;
	
	const carrouselBanners = events
		.filter((event) => event?.attributes?.banner_image?.filename !== null)
		.map((event, eventIndex) => {
		const {
			'banner_image': { filename, large },
			name, start_date, event_uri,
			website_languages, website,
		} = event?.attributes;

		const eventURL = event_uri
		? `https://event.eurobiomed.org/${website_languages?.[0]}/${event_uri}` : website;
		
		return ({
			id: event?.id,
			image: filename ? large.replace('/large/', '/original/') : '',
			title: name,
			date: moment(start_date).format('YYYY-MM-DD'),
			eventUri: event_uri,
			website: eventURL,
			language: website_languages[0]
		})
	});

	const carrouselLength = carrouselBanners.length;
	const [index, setIndex] = useState(0);

	const nextBanner = () => {
		if(index !== carrouselBanners.length - 1){
			setIndex(index + 1);
		};
		if (index === carrouselBanners.length - 1){
			setIndex(0);
		};
	};

	const prevBanner = () => {
		if(index !== 0){
			setIndex(index - 1);
		};
		if (index === 0){
			setIndex(carrouselBanners.length - 1);
		};
	};

	const bannerDot = index => {
		setIndex(index);
	};

	const initialSwipePosition = useRef(0);
	const finalSwipePosition = useRef(0);
	const swipeAllowedTime = 200;
	var swipeElapsedTime = 0;
	var swipeStartTime = 0;

	const onTouchStartHandler = (event) => {
		swipeStartTime = new Date().getTime();
		const touchPosition = event?.touches[0]?.clientX;
		if (touchPosition) initialSwipePosition.current = touchPosition;
	};
	const onTouchMoveHandler = (event) => {
		const touchPosition = event?.touches[0]?.clientX;
		if (touchPosition) finalSwipePosition.current = touchPosition;
	}
	const onTouchEndHandler = (event) => {
		swipeElapsedTime = new Date().getTime() - swipeStartTime;
		const touchPosition = event?.touches[0]?.clientX;
		if (touchPosition) finalSwipePosition.current = touchPosition;
		if (initialSwipePosition !== 0 && finalSwipePosition !== 0) {
			const swipeThreshold = window.screen.width * 0.1;
			const swipeVector = finalSwipePosition.current - initialSwipePosition.current;
			const swipeDirection = swipeVector / Math.abs(swipeVector);
			const swipeMagnitude = Math.abs(swipeVector);
			if (swipeDirection === 1 && swipeElapsedTime >= swipeAllowedTime && swipeMagnitude > swipeThreshold) prevBanner();
			if (swipeDirection === -1 && swipeElapsedTime >= swipeAllowedTime && swipeMagnitude > swipeThreshold) nextBanner();
		};

		initialSwipePosition.current = 0;
		finalSwipePosition.current = 0;
		swipeElapsedTime = 0;
		swipeStartTime = 0;
	}
	const onTouchCanelHandler = (event) => {
		event.preventDefault();
	}

	useEffect(() => {
		let autoIndex = (index + 1) % carrouselBanners.length;
		let timer = setTimeout(() => setIndex(autoIndex), 5000);
		return () => {
			clearTimeout(timer);
		};
	}, [index, carrouselBanners.length]);

	const bannerImages = carrouselBanners.map((banner, imageIndex) => (
		<Box>
			<img
				key={banner.id}
				src={banner.image}
				alt=""
				style={{
					opacity: imageIndex === index ? 1 : 0,
					width: '100vw',
					position: 'absolute',
					top: 0,
					bottom: 0,
					left: 0,
					right: 0,
					transition: 'opacity ease-in-out 0.4s',
					aspectRatio: (!!banner.image && imageIndex === index) ? '24 / 7' : 'unset',
					objectFit: 'cover',
				}}
				onTouchStart={onTouchStartHandler}
				onTouchMove={onTouchMoveHandler}
				onTouchEnd={onTouchEndHandler}
				onTouchCancel={onTouchCanelHandler}
			/>
			<img
				key={banner.id}
				alt=""
				src={banner.image}
				style={{

					width: '100vw',
					visibility: 'hidden',
					display: (!!banner.image && imageIndex === index) ? 'block' : 'none',
					aspectRatio: imageIndex === index ? '24 / 7' : 'unset',
				}}
			/>
		</Box>
	));

	return (
		<Box sx={classes.allCarousel}>
			<Box sx={carouselClasses.bannerContainer}>
				<Box style={{ position: 'relative' }}>
					{!!carrouselLength && bannerImages}
				</Box>
			</Box>

			<Box sx={classes.carouselFooter}>
				<Box sx={carouselClasses.containerDots}>
					{carrouselLength > 1 && <CrsButton moveBanner={prevBanner} direction={"prev"}/>}
					{Array.from({length: carrouselLength}).map((dotItem, dotIndex) => (
						<Box
							onClick={() => bannerDot(dotIndex)}
							sx={[
								carouselClasses.dot,
								index === dotIndex && carouselClasses.dotActive
							]}
						>
						</Box>
					))}
					{carrouselLength > 1 && <CrsButton moveBanner={nextBanner} direction={"next"}/>}
				</Box>
				<Box sx={classes.carouselInfo}>
					<Box sx={classes.descriptionInfo}>
						{carrouselBanners[index]?.title}
						<Box sx={classes.dateInfo}>Date: {moment(carrouselBanners[index]?.date).format('DD/MM/YYYY')}</Box>
					</Box>
					<a href={carrouselBanners[index]?.website} target='_blank' rel="noopener noreferrer" className={classes.buttonLink}>
						<Button variant="text" sx={classes.button}>
							Voir plus
						</Button>
					</a>
				</Box>
			</Box>
		</Box>
	)
}

export default Carousel;